import styled from "styled-components";
import { colors, darkModeColors } from "../../consts";

export const RadioInputLabel = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  gap: 10px;

  label {
    cursor: pointer;
    width: 100%;

    font-weight: ${(props) => (props?.checked ? 500 : 400)};
    font-size: 16px;
    line-height: 26px;
    color: ${(props) => (props?.checked ? colors.RAISIN_100 : colors.RAISIN_70)};
  }

  input[type="radio"] {
    -webkit-appearance: none;
    appearance: none;
    background: ${darkModeColors.WHITE_RAISIN_100};
    margin: 0;

    width: 20px;
    height: 20px;

    padding-block: 0;
    padding-inline: 0;

    border-radius: 50%;
    border: 1px solid ${darkModeColors.RAISIN_100_RAISIN_40};

    display: flex;
    flex-direction: row;
    justify-content: center;
    align-items: center;

    cursor: pointer;
  }

  input[type="radio"]:focus {
    outline: none;
  }

  input[type="radio"]::before {
    content: "";
    width: 12px;
    height: 12px;

    background: ${colors.TURQUOISE_100};

    border-radius: 50%;
    transform: scale(0);
    transition: 120ms transform ease-in-out;

    transform-origin: center;
  }

  input[type="radio"]:checked::before {
    transform: scale(1);
  }

  input[type="radio"]:disabled {
    border: 1px solid ${colors.RAISIN_10};
    cursor: default;
  }
`;
